import React from 'react';

function AddMaterialForm({ columns, newRow, onChange, onAdd }) {
  return (
    <div className="relative flex flex-col items-center justify-center min-w-[300px] max-w-full mx-auto p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-2xl backdrop-blur-lg">
      {/* Removed close button for consistent modal styling */}
      <div className="w-full flex flex-col items-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full mb-4">
          {columns.map((col) => (
            <input
              key={col}
              name={col}
              placeholder={col}
              value={newRow[col] || ''}
              onChange={onChange}
              className="p-2 bg-gray-900 bg-opacity-80 border border-gray-700 rounded text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          ))}
        </div>
        <button
          onClick={onAdd}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold shadow-md transition"
        >
          Add Material
        </button>
      </div>
    </div>
  );
}

export default AddMaterialForm;
